import type { SignupMethod } from '@rw/shared';

export const METHOD_LABEL: Record<SignupMethod, string> = {
  email: 'Email',
  strava: 'Strava',
  google: 'Google',
  facebook: 'Facebook',
};

export const pct = (n: number, of: number) => (of > 0 ? `${Math.round((n / of) * 100)}%` : '—');

/** Readable names for the audit log's action codes (English keys, translated at render). */
export const AUDIT_ACTION_LABEL: Record<string, string> = {
  'user.delete': 'Deleted an account',
  'user.self_delete': 'Deleted their own account',
  'event.approve': 'Approved an event',
  'event.reject': 'Declined an event',
  'event.moderate': 'Moderated an event',
  'event.sponsors': 'Set an event’s sponsors',
  'settings.update': 'Changed the game settings',
  'region.open': 'Opened a city',
  'region.close': 'Closed a city',
  'region.reopen_runs': 'Judged runs again in a city',
  'brand.create': 'Added a brand',
  'brand.update': 'Edited a brand',
  'brand.archive': 'Deleted a brand',
  'brand.restore': 'Restored a brand',
  'campaign.create': 'Created a campaign',
  'campaign.update': 'Edited a campaign',
  'campaign.cells': 'Set the campaign’s map cells',
  'offer.create': 'Created an offer',
  'offer.update': 'Edited an offer',
  'offer.codes': 'Added offer codes',
  'offer.codes.remove': 'Removed unused offer codes',
  'sponsorship.create': 'Added a ledger entry',
  'sponsorship.update': 'Edited a ledger entry',
  'sponsorship.delete': 'Deleted a ledger entry',
};
